export const sanitizeHeaderAnchors = text => {
  if ((text && !text.length) || !text) return
  return text
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
}

export const trimTabsAndNewLines = text => {
  if ((text && !text.length) || !text) return
  return text.replace(/ {2}|\r\n|\n|\r/gm, '')
}

export const trimCommentsAndNewLines = text => {
  if ((text && !text.length) || !text) return
  return text.replace(/ {2}|\r\n|\n|\r/gm, '')
}

export const extractHostname = url => {
  let hostname
  // find & remove protocol (http, ftp, etc.) and get hostname

  if (url.indexOf('//') > -1) {
    hostname = url.split('/')[2]
  } else {
    hostname = url.split('/')[0]
  }

  // find & remove port number
  hostname = hostname.split(':')[0]
  // find & remove "?"
  hostname = hostname.split('?')[0]

  return hostname
}
